import React, { useRef, useEffect } from "react";
import destination from "@turf/destination";
import { debounce } from "lodash";

function CanvasDarkness({ map, darknessOpacity = 0.8, histories = []}) {
  const canvasRef = useRef(null);
  const offscreenCanvasRef = useRef(null); 
  const gradientCache = useRef(new Map());

  // HEXカラーコードをRGBA形式に変換する関数
  function hexToRgba(hex, opacity) {
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !map) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // オフスクリーンキャンバスの初期化
    if (!offscreenCanvasRef.current) {
      offscreenCanvasRef.current = document.createElement("canvas");
    }

    // キャンバスサイズを更新する関数
    const updateCanvasSize = () => {
      const width = canvas.offsetWidth;
      const height = canvas.offsetHeight;
      canvas.width = width * window.devicePixelRatio;
      canvas.height = height * window.devicePixelRatio;
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    };

    // キャンバスサイズの変更をデバウンス
    const debouncedUpdateCanvasSize = debounce(updateCanvasSize, 100);

    updateCanvasSize();
    window.addEventListener("resize", debouncedUpdateCanvasSize);

    // 描画を行う関数
    const draw = () => {
      
      // キャンバスをクリアし、暗闇を塗る
      
      ctx.fillStyle = `rgba(0, 0, 0, ${darknessOpacity})`;
      //ctx.fillRect(0, 0, canvas.width, canvas.height);

      // オフスクリーンキャンバスの作成
      const offscreenCanvas = document.createElement("canvas");
      offscreenCanvas.width = canvas.width;
      offscreenCanvas.height = canvas.height;
      const offscreenCtx = offscreenCanvas.getContext("2d");
      if (!offscreenCtx) return;

      // グラデーションと塗りつぶし用の円を収集する配列
      const fillCircles = [];

      // historiesを描画
      histories.forEach(({ lat, lng, opacity, r,color }) => {
        const projected = map.project([lng, lat]); // 地図座標をキャンバス座標に変換
        const { x, y } = projected;

        // 半径に基づきセグメント数を動的に調整
        const adjustedSegments = Math.max(30, Math.floor(r / 10));
        const radius = Math.max(r, 0); // 半径（メートル単位）
        const circle = [];

        // Turf.jsを使用して円の座標を計算
        for (let i = 0; i < adjustedSegments; i++) {
          const angle = (i / adjustedSegments) * 360;
          const point = destination([lng, lat], radius / 1000, angle, { units: "kilometers" }).geometry.coordinates;
          circle.push(map.project(point));
        }

        // 円が視界内にあるか確認
        const isCircleVisible = circle.some(({ x, y }) => x >= 0 && x <= canvas.width && y >= 0 && y <= canvas.height);
        if (!isCircleVisible) return;

     
        fillCircles.push({ circle, color, opacity,r });
        
        
        
        // else {
        //   // 輪郭の円を描画
        //   offscreenCtx.beginPath();
        //   circle.forEach(({ x, y }, idx) => {
        //     idx === 0 ? offscreenCtx.moveTo(x, y) : offscreenCtx.lineTo(x, y);
        //   });

          
        //   offscreenCtx.closePath();
        //   offscreenCtx.fillStyle = "rgb(0, 0, 0)";
        //   offscreenCtx.fill();

          // グラデーションを収集
          // if (type === "grad") {
          //   const gradientKey = `${x},${y},${radius}`;
          //   let gradient = gradientCache.current.get(gradientKey);
          //   if (!gradient) {
          //     gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
          //     gradient.addColorStop(0, hexToRgba(color, opacity));
          //     gradient.addColorStop(0.5, "rgba(255, 255, 255, 0.11)");
          //     gradientCache.current.set(gradientKey, gradient);
          //   }
          //   gradCircles.push({ circle, center: { x, y }, radius, color, opacity });
          // }
        // }
      });

      // オフスクリーンキャンバスをメインキャンバスに適用
      ctx.globalCompositeOperation = "destination-out";
      ctx.drawImage(offscreenCanvas, 0, 0);
      
      ctx.globalCompositeOperation = "source-over";

      // 面積計算のコールバック
      // if (onCalculateArea) {
      //   const imageData = offscreenCtx.getImageData(0, 0, offscreenCanvas.width, offscreenCanvas.height);
      //   const data = imageData.data;
      //   const visiblePixelCount = Array.from(data).filter((_, i) => i % 4 === 3 && data[i] !== 0).length;
      //   onCalculateArea(visiblePixelCount);
      // }


       // 塗りつぶし円の描画
       fillCircles.forEach(({ circle, color, opacity }) => {
        ctx.beginPath();
        circle.forEach(({ x, y }, idx) => {
          idx === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        });
        ctx.closePath();
        ctx.fillStyle = hexToRgba("000000", 0.5);
        ctx.fill();
      });

      // グラデーション円の描画
      // gradCircles.forEach(({ circle, center: { x, y }, radius }) => {
      //   const gradientKey = `${x},${y},${radius}`;
      //   let gradient = gradientCache.current.get(gradientKey);
      //   if (!gradient) {
      //     gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
      //     gradient.addColorStop(0, hexToRgba(color, opacity));
      //     gradient.addColorStop(0.2, "rgba(255, 255, 255, 0)");
      //     gradientCache.current.set(gradientKey, gradient);
      //   }

      //   ctx.beginPath();
      //   circle.forEach(({ x, y }, idx) => {
      //     idx === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      //   });
      //   ctx.closePath();
      //   ctx.fillStyle = gradient;
      //   ctx.fill();
      // });

     
    };

    // 描画のデバウンス
    const debouncedDraw = debounce(draw, 50);
    draw();

    // イベントリスナーの登録
    map.on("move", debouncedDraw);
    map.on("zoom", debouncedDraw);
    map.on("resize", debouncedDraw);

    // クリーンアップ
    return () => {
      window.removeEventListener("resize", debouncedUpdateCanvasSize);
      map.off("move", debouncedDraw);
      map.off("zoom", debouncedDraw);
      map.off("resize", debouncedDraw);
    };
  }, [map, darknessOpacity, histories]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 2,
      }}
    />
  );
}

export default CanvasDarkness;
